<template>
  <div class="puhui-orders">
    <el-card shadow="never" class="orders-card">
      <div class="search-bar">
        <el-input v-model="search" placeholder="订单号/手机号" prefix-icon="el-icon-search" size="small" style="width: 240px;" clearable />
        <el-select v-model="status" placeholder="全部状态" size="small" style="width: 140px;" clearable @change="fetchOrders">
          <el-option label="待付款" :value="0" />
          <el-option label="待发货" :value="1" />
          <el-option label="已发货" :value="2" />
          <el-option label="已完成" :value="3" />
          <el-option label="售后退款" :value="4" />
          <el-option label="售后申请中" :value="5" />
          <el-option label="已取消" :value="6" />
        </el-select>
        <el-button type="danger" size="small" @click="fetchOrders">搜索</el-button>
      </div>

      <el-table :data="orders" style="width: 100%;" border stripe v-loading="loading">
        <el-table-column prop="orderNo" label="订单号" width="200" />
        <el-table-column prop="product" label="商品" min-width="180" />
        <el-table-column prop="user" label="用户" width="180" />
        <el-table-column label="金额" width="120">
          <template slot-scope="scope">
            <span class="price-bold">¥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status_code)" size="small">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status_code === 1" type="danger" size="small" @click="handleDeliver(scope.row)">发货</el-button>
            <el-button v-if="scope.row.status_code === 4" type="warning" size="small" @click="handleRefund(scope.row)">处理退款</el-button>
            <el-button v-if="scope.row.status_code === 2 || scope.row.status_code === 3" type="text" size="small" @click="handleLogistics(scope.row)">查物流</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <span>共 {{ total }} 条记录</span>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit" :current-page.sync="page" @current-change="fetchOrders" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getCommonOrders, orderShipment, orderRefund } from '@/api'

export default {
  name: 'PuhuiOrders',
  data() {
    return {
      search: '',
      status: '',
      orders: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false
    }
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    fetchOrders() {
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.search) params.keyword = this.search
      if (this.status !== '') params.order_status = this.status

      getCommonOrders(params).then(res => {
        this.orders = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.$message.error('获取订单列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleDeliver(row) {
      this.$confirm(`确认发货: ${row.orderNo}？`, '发货确认', { type: 'success' }).then(() => {
        orderShipment({ orderNo: row.orderNo }).then(() => {
          this.$message.success('发货成功')
          this.fetchOrders()
        }).catch(() => {
          this.$message.error('发货失败')
        })
      }).catch(() => {})
    },
    handleRefund(row) {
      this.$confirm(`处理退款: ${row.orderNo}？`, '退款处理', { type: 'warning' }).then(() => {
        orderRefund({ orderNo: row.orderNo }).then(() => {
          this.$message.success('退款处理完成')
          this.fetchOrders()
        }).catch(() => {
          this.$message.error('退款处理失败')
        })
      }).catch(() => {})
    },
    statusTagType(code) {
      const map = { 0: 'info', 1: 'danger', 2: '', 3: 'success', 4: 'warning', 5: 'warning' }
      return map[code] || 'info'
    },
    handleLogistics(row) { this.$message.info(`查询物流: ${row.orderNo}`) }
  }
}
</script>

<style scoped>
.orders-card { border-radius: 8px; }
.search-bar { display: flex; gap: 12px; padding: 0 0 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px; }
.price-bold { font-weight: bold; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
</style>
